/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-22T09:43:57.597
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listHouseRentalInfo,
	listHouseRentalInfoInit,
	listHouseRentalInfoByAuthorizations,
	deleteHouseRentalInfo
} from '@api/lcf/HouseRentalInfo';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listHouseRentalInfo({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHouseRentalInfo(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listHouseRentalInfoByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHouseRentalInfoByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listHouseRentalInfoInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHouseRentalInfoInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteHouseRentalInfo({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteHouseRentalInfo({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
